import { MenuItem, Select } from '@mui/material';
import EmployeeAvatar from 'components/@home/EmployeeAvatar';
import { bool, func, string } from 'prop-types';
import React, { Component } from 'react';
import channelShape from 'shapes/channel';
import employeeShape from 'shapes/employee';
import connector from './connector';

const selectSx = theme => ({
  border: `1px solid ${theme.palette.secondary.extraLight}`,
  borderRadius: '6px',
  boxShadow: '0 1px 2px 0 rgba(2, 2, 3, 0.05)',
  '& .MuiOutlinedInput-notchedOutline': {
    display: 'none',
  },
  '& .MuiSelect-select': {
    padding: '3px',
    paddingRight: '24px !important',
  },
  '& .MuiSelect-icon': {
    right: 0,
  },
});

class ChatSelect extends Component {
  handleChange = ({ target: { name, value } }) => {
    const { onChange } = this.props;
    onChange(name, value);
  };

  render() {
    const { name, value, employee, channel, isMember } = this.props;
    if (!employee) return null;

    return (
      <Select sx={selectSx} name={name} value={!isMember || value} onChange={this.handleChange}>
        {isMember && (
          <MenuItem value={false}>
            <EmployeeAvatar employee={employee} />
          </MenuItem>
        )}
        <MenuItem value={true}>
          <EmployeeAvatar employee={{ name: channel.name, avatar: channel.avatar }} />
        </MenuItem>
      </Select>
    );
  }
}

ChatSelect.propTypes = {
  employee: employeeShape,
  channel: channelShape.isRequired,
  name: string.isRequired,
  value: bool.isRequired,
  onChange: func.isRequired,
  isMember: bool.isRequired,
};

ChatSelect.defaultProps = {
  employee: null,
};

export default connector(ChatSelect);
